import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Download,
} from '../../../../components';

import '../style.scss';

const ParagraphDownload = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const downloads = entity.getIn(['field_download_s_']);

  return (
    <Container className="Paragraph ParagraphDownload">
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          {title && <h2>{title}</h2>}
          {downloads && downloads.size > 0 && (
            downloads.map((download, index) => {
              const uuid = download.getIn(['entity', 'uuid', 0, 'value']);
              const downloadTitle = download.get('title');
              const downloadLink = download.get('source');
              const ext = downloadLink.split('.').pop();

              return (
                <Download
                  key={uuid}
                  title={downloadTitle}
                  link={downloadLink}
                  fileType={ext}
                />
              );
            })
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphDownload;
